import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNotification } from '@starjack/features/notifications';
import { Agency } from '@/models/agency';
import { useDeleteAgencyMutation } from '@/api/v2/agency';

type AgencyDeleteDialogProps = {
    agency: Agency;
    open: boolean;
    onClose: () => void;
};

export const AgencyDeleteDialog: FunctionComponent<AgencyDeleteDialogProps> = ({
    agency,
    open,
    onClose,
}) => {
    const [deleteAgency, { isLoading }] = useDeleteAgencyMutation();
    const { addNotification } = useNotification();

    const onRefundTicket = () => {
        deleteAgency(agency)
            .unwrap()
            .then(() => {
                addNotification({
                    message: 'Agentur erfolgreich gelöscht',
                    type: 'success',
                });
            })
            .catch(() => {
                addNotification({
                    message:
                        'Fehler beim Löschen. Bitte später noch einmal versuchen',
                    type: 'error',
                });
            })
            .finally(() => {
                onClose();
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Agentur löschen</DialogTitle>
            <DialogContent>
                {!!agency && (
                    <DialogContentText>
                        Soll die Agentur{' '}
                        <Typography sx={{ fontWeight: 600 }} component='span'>
                            {agency.username}
                        </Typography>{' '}
                        wirklich gelöscht werden?
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <LoadingButton
                        onClick={onRefundTicket}
                        variant='contained'
                        loading={isLoading}
                    >
                        Löschen
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
